export default __webpack_public_path__ + "static/media/profile.dde91954.jpg";